import { PopupOfferType } from "Utility/Helpers/IAP/PopupOffers";

export interface IPerSessionData {
    offersSeen: PopupOfferType[];
    isNewUser: boolean;

    hasClickedXPromoHUDButton: boolean;
    debugXPromo?: boolean;
}

export const initialPerSessionDataState: IPerSessionData = {
    offersSeen: [],
    isNewUser: false,
    hasClickedXPromoHUDButton: false,
};
